// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var $$String = require("rescript/lib/js/string.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Webapi__Dom__Element = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Element.bs.js");
var HTMLNodes$SmartcutsMacros = require("../../bs-select/src/HTMLNodes.bs.js");
var ListUtils$SmartcutsMacros = require("../../bs-utils/src/ListUtils.bs.js");
var RandomCss$SmartcutsMacros = require("../../bs-select/src/RandomCss.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var RegExUtils$SmartcutsMacros = require("../../bs-utils/src/RegExUtils.bs.js");
var DOM__Shadow$SmartcutsMacros = require("./DOM__Shadow.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");
var SelectorTree$SmartcutsMacros = require("../../bs-select/src/SelectorTree.bs.js");

function contains(attr, value, attributes) {
  return $$Array.exists((function (param) {
                if (Caml_obj.caml_equal(param[0], attr)) {
                  if (value !== undefined) {
                    return Caml_obj.caml_equal(param[1], Caml_option.valFromOption(value));
                  } else {
                    return true;
                  }
                } else {
                  return false;
                }
              }), attributes);
}

var Attributes = {
  contains: contains
};

function selectorNode_encode(v) {
  return SelectorTree$SmartcutsMacros.$$Node.t_encode(v);
}

function selectorNode_decode(v) {
  return SelectorTree$SmartcutsMacros.$$Node.t_decode(v);
}

function selector_encode(v) {
  return Decco.listToJson(selectorNode_encode, v);
}

function selector_decode(v) {
  return Decco.listFromJson(selectorNode_decode, v);
}

function elementSelector_encode(v) {
  switch (v.TAG | 0) {
    case /* Selector */0 :
        return [
                "Selector",
                Decco.listToJson(selectorNode_encode, v._0)
              ];
    case /* CssSelector */1 :
        return [
                "CssSelector",
                Decco.stringToJson(v._0)
              ];
    case /* XPath */2 :
        return [
                "XPath",
                Decco.stringToJson(v._0)
              ];
    
  }
}

function elementSelector_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "CssSelector" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CssSelector */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Selector" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.listFromJson(selectorNode_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Selector */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "XPath" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* XPath */2,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function selectorNode(tagName, classNamesOpt, id, attributesOpt, index, innerText, isScrollable, attributeBlacklistOpt, param) {
  var classNames = classNamesOpt !== undefined ? classNamesOpt : [];
  var attributes = attributesOpt !== undefined ? attributesOpt : /* [] */0;
  var attributeBlacklist = attributeBlacklistOpt !== undefined ? attributeBlacklistOpt : [];
  return {
          id: id,
          tagName: tagName,
          classNames: classNames,
          attributes: $$Array.of_list(attributes),
          index: index,
          innerText: innerText,
          isScrollable: isScrollable,
          attributeBlacklist: attributeBlacklist
        };
}

function addNode(node, selector) {
  return Belt_List.concat(selector, {
              hd: node,
              tl: /* [] */0
            });
}

function stringify(componentFilterOpt, useScope, selector) {
  var componentFilter = componentFilterOpt !== undefined ? componentFilterOpt : (function (param) {
        return true;
      });
  return SelectorTree$SmartcutsMacros.stringify(useScope, List.map((function (node) {
                    return Curry._1(SelectorTree$SmartcutsMacros.$$Node.Components.toNode, List.filter(componentFilter)(Curry._1(SelectorTree$SmartcutsMacros.$$Node.Components.fromSelectorNode, node)));
                  }), selector));
}

function stringifyElementSelector(v) {
  switch (v.TAG | 0) {
    case /* Selector */0 :
        return "Selector(" + (stringify(undefined, true, v._0) + ")");
    case /* CssSelector */1 :
        return "CssSelector(" + (v._0 + ")");
    case /* XPath */2 :
        return "XPath(" + (v._0 + ")");
    
  }
}

function hasSelectionCapability(selector) {
  var node = Belt_List.get(selector, List.length(selector) - 1 | 0);
  if (node === undefined) {
    return true;
  }
  var match = node.tagName;
  if (match === undefined) {
    return true;
  }
  switch (match) {
    case "input" :
        var func = SelectorTree$SmartcutsMacros.$$Node.maybeGetAttributeValue;
        var type_ = Curry._2(func, "type", node);
        if (type_ === undefined) {
          return true;
        }
        var match$1 = type_.toLowerCase();
        switch (match$1) {
          case "" :
          case "password" :
          case "search" :
          case "tel" :
          case "text" :
          case "url" :
              return true;
          default:
            return false;
        }
    case "textarea" :
        return true;
    default:
      return true;
  }
}

function deepEquals(selectorA, selectorB) {
  if (List.length(selectorA) === List.length(selectorB)) {
    return Belt_List.reduceWithIndex(selectorA, true, (function (acc, nodeA, i) {
                  var nodeB = Belt_List.getExn(selectorB, i);
                  if (acc) {
                    return SelectorTree$SmartcutsMacros.$$Node.deepEquals(nodeA, nodeB);
                  } else {
                    return false;
                  }
                }));
  } else {
    return false;
  }
}

function shouldIgnoreId(idPrefixesToIgnore, id) {
  if (id.indexOf("-") === -1) {
    return [
            idPrefixesToIgnore,
            false
          ];
  }
  var _matchingPrefix = ArrayUtils$SmartcutsMacros.firstMatch((function (param) {
          return id.startsWith(param);
        }), idPrefixesToIgnore);
  if (_matchingPrefix !== undefined) {
    return [
            idPrefixesToIgnore,
            true
          ];
  }
  var maybePrefix = ArrayUtils$SmartcutsMacros.shortcutWithState([], (function (previousPrefix, component) {
          var prefix = Belt_Array.concat(previousPrefix, [component]);
          var prefixString = prefix.join("-").concat("-");
          var arg = Array.prototype.slice.call(document.querySelectorAll("*[id^=" + (window.CSS.escape(prefixString) + "]")));
          var otherIdsMatchingPrefix = (function (param) {
                return ArrayUtils$SmartcutsMacros.filterMap(param, arg);
              })(function (node) {
                var maybeElement = Webapi__Dom__Element.ofNode(node);
                if (maybeElement === undefined) {
                  return ;
                }
                var element = Caml_option.valFromOption(maybeElement);
                if (element.id === id) {
                  return ;
                } else {
                  return element.id;
                }
              });
          var components = Belt_Array.map(otherIdsMatchingPrefix, (function (param) {
                  var arg = Belt_Array.get(param.slice(prefixString.length).split("-"), 0);
                  var param$1 = "Expect to get idComponent after prefix " + (StringUtils$SmartcutsMacros.quote(prefixString) + (" from id " + StringUtils$SmartcutsMacros.quote(param)));
                  return OptionUtils$SmartcutsMacros.getExn(param$1, arg);
                }));
          var componentsMatchingLength = Belt_Array.keep(components, (function (component) {
                  return component.length === component.length;
                }));
          if (componentsMatchingLength.length !== 0) {
            if (Belt_Array.some(componentsMatchingLength, (function (component$p) {
                      return component$p === component;
                    }))) {
              return [
                      prefix,
                      undefined
                    ];
            } else {
              return [
                      prefix,
                      prefix
                    ];
            }
          } else {
            return [
                    prefix,
                    []
                  ];
          }
        }), id.split("-"));
  if (maybePrefix === undefined) {
    return [
            idPrefixesToIgnore,
            false
          ];
  }
  if (maybePrefix.length === 0) {
    return [
            idPrefixesToIgnore,
            false
          ];
  }
  var prefixToIgnore = maybePrefix.join("-");
  return [
          Belt_Array.concat(idPrefixesToIgnore, [prefixToIgnore]),
          true
        ];
}

var attributesToAvoidComparing = [
  "alt",
  "autofocus",
  "on",
  "checked",
  "selected",
  "style",
  "width",
  "height",
  "color",
  "bgcolor",
  "background",
  "border"
];

function websiteSpecificAttributesToAvoidComparing(origin) {
  switch (origin) {
    case "https://drive.google.com" :
        return [
                "data-complete",
                "aria-activedescendant",
                "jsaction"
              ];
    case "https://www.linkedin.com" :
        return ["data-artdeco-is-focused"];
    default:
      return ;
  }
}

function websiteSpecificClassNamesToAvoidComparing(origin) {
  if (origin === "https://www.linkedin.com") {
    return [
            "cursor-text",
            "cursor-pointer"
          ];
  }
  
}

function pruneSelectorTreeNodeUsingOriginBlacklist(origin, selectorTreeNode) {
  var attributes = selectorTreeNode.attributes;
  var classNames = selectorTreeNode.classNames;
  var match = websiteSpecificClassNamesToAvoidComparing(origin);
  var match$1 = websiteSpecificAttributesToAvoidComparing(origin);
  if (match !== undefined) {
    if (match$1 !== undefined) {
      return {
              id: selectorTreeNode.id,
              tagName: selectorTreeNode.tagName,
              classNames: Belt_Array.keep(classNames, (function (className) {
                      return !$$Array.mem(className, match);
                    })),
              attributes: Belt_Array.keep(attributes, (function (param) {
                      return !$$Array.mem(param[0], match$1);
                    })),
              index: selectorTreeNode.index,
              innerText: selectorTreeNode.innerText,
              isScrollable: selectorTreeNode.isScrollable,
              attributeBlacklist: selectorTreeNode.attributeBlacklist
            };
    } else {
      return {
              id: selectorTreeNode.id,
              tagName: selectorTreeNode.tagName,
              classNames: Belt_Array.keep(classNames, (function (className) {
                      return !$$Array.mem(className, match);
                    })),
              attributes: selectorTreeNode.attributes,
              index: selectorTreeNode.index,
              innerText: selectorTreeNode.innerText,
              isScrollable: selectorTreeNode.isScrollable,
              attributeBlacklist: selectorTreeNode.attributeBlacklist
            };
    }
  } else if (match$1 !== undefined) {
    return {
            id: selectorTreeNode.id,
            tagName: selectorTreeNode.tagName,
            classNames: selectorTreeNode.classNames,
            attributes: Belt_Array.keep(attributes, (function (param) {
                    return !$$Array.mem(param[0], match$1);
                  })),
            index: selectorTreeNode.index,
            innerText: selectorTreeNode.innerText,
            isScrollable: selectorTreeNode.isScrollable,
            attributeBlacklist: selectorTreeNode.attributeBlacklist
          };
  } else {
    return selectorTreeNode;
  }
}

function attributeNamesToUseForAttributeExistence(currentUrl, attributesFilter, param) {
  var attributesToAvoidComparing$1 = Belt_Array.concat(Belt_Option.getWithDefault(Belt_Option.flatMap(currentUrl, (function (url) {
                  var match = new URL(url);
                  return websiteSpecificAttributesToAvoidComparing(match.origin);
                })), []), attributesToAvoidComparing);
  return $$Array.concat({
              hd: param.id !== undefined ? ["id"] : [],
              tl: {
                hd: Belt_Array.keep(Belt_Array.keep(Belt_Array.concat(Belt_Array.map(param.attributes, (function (prim) {
                                    return prim[0];
                                  })), param.classNames.length !== 0 ? ["class"] : []), attributesFilter), (function (attrName) {
                        return !$$Array.mem(attrName, attributesToAvoidComparing$1);
                      })),
                tl: /* [] */0
              }
            });
}

function toCssSelectorUsingTagChainAndAttributeExistence(useScope, attributesFilter, currentUrl, selector) {
  return (
          useScope ? ":scope " : ""
        ) + $$String.concat(" > ", List.mapi((function (selectorNodeIndex, selectorNode) {
                    var tagName = selectorNode.tagName;
                    var tagName$1 = tagName !== undefined ? tagName : "*";
                    var _id = selectorNode.id;
                    if (_id !== undefined) {
                      return "" + tagName$1 + "[id]";
                    }
                    var attributes = attributeNamesToUseForAttributeExistence(currentUrl, Curry._1(attributesFilter, selectorNodeIndex), selectorNode);
                    if (attributes.length !== 0) {
                      return Belt_Array.reduce(attributes, tagName$1, (function (cssSelector, attrKey) {
                                    if (attrKey.startsWith("data-") && RegExUtils$SmartcutsMacros.endsWithNumber(attrKey)) {
                                      return cssSelector;
                                    }
                                    var key = SelectorTree$SmartcutsMacros.$$Node.maybeStringifyAttributeKey(attrKey);
                                    if (key !== undefined) {
                                      return cssSelector + ("[" + key + "]");
                                    } else {
                                      return cssSelector;
                                    }
                                  }));
                    } else {
                      return tagName$1;
                    }
                  }), selector));
}

function removeGeneratedIdsFromSelector(selector) {
  return ListUtils$SmartcutsMacros.mapWithState([], (function (idPrefixesToIgnore, selectorNode) {
                var id = selectorNode.id;
                if (id === undefined) {
                  return [
                          idPrefixesToIgnore,
                          selectorNode
                        ];
                }
                var match = shouldIgnoreId(idPrefixesToIgnore, id);
                return [
                        match[0],
                        match[1] ? ({
                              id: undefined,
                              tagName: selectorNode.tagName,
                              classNames: selectorNode.classNames,
                              attributes: selectorNode.attributes,
                              index: selectorNode.index,
                              innerText: selectorNode.innerText,
                              isScrollable: selectorNode.isScrollable,
                              attributeBlacklist: selectorNode.attributeBlacklist
                            }) : selectorNode
                      ];
              }), selector);
}

function blacklistedValueForAttrName(attrKey, matchingElements, valueToRetain) {
  return Belt_Array.keepMap(matchingElements, (function (element) {
                var value = element.getAttribute(attrKey);
                if (!(value == null) && value !== valueToRetain) {
                  return value;
                }
                
              }));
}

function selfAndAllAncestors(element) {
  var parentElement = element.parentElement;
  if (parentElement == null) {
    return [element];
  } else {
    return Belt_Array.concat([element], selfAndAllAncestors(parentElement));
  }
}

function blacklistAttributeValues(attrKeysToBlacklist, selector) {
  var func = function (param, param$1, param$2) {
    return toCssSelectorUsingTagChainAndAttributeExistence(true, param, param$1, param$2);
  };
  var cssSelector = Curry._3(func, (function (param, param$1) {
          return true;
        }), undefined, selector);
  var elementChains = Belt_Array.map(Belt_Array.keepMap(Array.prototype.slice.call(document.querySelectorAll(cssSelector)), Webapi__Dom__Element.ofNode), selfAndAllAncestors);
  return Belt_List.mapWithIndex(selector, (function (index, selectorNode) {
                var matchingElements = Belt_Array.map(elementChains, (function (elements) {
                        return Caml_array.get(elements, index);
                      }));
                var attributeBlacklist = Belt_Array.keepMap(selectorNode.attributes, (function (param) {
                        var attrKey = param[0];
                        if ($$Array.mem(attrKey, attrKeysToBlacklist)) {
                          return [
                                  attrKey,
                                  blacklistedValueForAttrName(attrKey, matchingElements, param[1])
                                ];
                        }
                        
                      }));
                return {
                        id: selectorNode.id,
                        tagName: selectorNode.tagName,
                        classNames: selectorNode.classNames,
                        attributes: selectorNode.attributes,
                        index: selectorNode.index,
                        innerText: selectorNode.innerText,
                        isScrollable: selectorNode.isScrollable,
                        attributeBlacklist: attributeBlacklist
                      };
              }));
}

function forDomElement(domElement) {
  return SelectorTree$SmartcutsMacros.processInnerText(100, 2, [
              "button",
              "a"
            ], ["body"], SelectorTree$SmartcutsMacros.fromHTMLNodes(HTMLNodes$SmartcutsMacros.forDomElementAndItsAncestors(undefined, domElement)));
}

var forHtmlElement = forDomElement;

var forDomEventTarget = forDomElement;

function forDomEvent($$event) {
  return forDomElement(DOM__Shadow$SmartcutsMacros.getTargetFromEvent($$event));
}

function stripGeneratedIds(node) {
  var id = node.id;
  if (id !== undefined && RandomCss$SmartcutsMacros.isGeneratedId(id)) {
    return {
            id: undefined,
            tagName: node.tagName,
            classNames: node.classNames,
            attributes: node.attributes,
            index: node.index,
            innerText: node.innerText,
            isScrollable: node.isScrollable,
            attributeBlacklist: node.attributeBlacklist
          };
  } else {
    return node;
  }
}

var $$Node = {
  stripGeneratedIds: stripGeneratedIds
};

function stripGeneratedIds$1(selector) {
  return List.map(stripGeneratedIds, selector);
}

function getCommonAncestor(aSelector, bSelector) {
  var loop = function (_aSelector, _bSelector, _commonAncestorSelectorAsArray) {
    while(true) {
      var commonAncestorSelectorAsArray = _commonAncestorSelectorAsArray;
      var bSelector = _bSelector;
      var aSelector = _aSelector;
      if (!aSelector) {
        return commonAncestorSelectorAsArray;
      }
      if (!bSelector) {
        return commonAncestorSelectorAsArray;
      }
      var _currNodeA = aSelector.hd;
      var match = Curry._2(SelectorTree$SmartcutsMacros.$$Node.Diff.withNode, _currNodeA, bSelector.hd);
      if (typeof match !== "number") {
        if (match.TAG !== /* ClassNames */3) {
          return commonAncestorSelectorAsArray;
        }
        if (match._2.length === 0) {
          return commonAncestorSelectorAsArray;
        }
        
      }
      _commonAncestorSelectorAsArray = $$Array.append(commonAncestorSelectorAsArray, [_currNodeA]);
      _bSelector = bSelector.tl;
      _aSelector = aSelector.tl;
      continue ;
    };
  };
  return $$Array.to_list(loop(aSelector, bSelector, []));
}

function selectsParentOrEquivElement(aSelector, bSelector) {
  var _result;
  var _aSelector = aSelector;
  var _bSelector = bSelector;
  while(true) {
    var bSelector$1 = _bSelector;
    var aSelector$1 = _aSelector;
    var result = _result;
    if (result !== undefined) {
      return result;
    }
    if (!aSelector$1) {
      return true;
    }
    var aSelector$p = aSelector$1.tl;
    if (!bSelector$1) {
      return false;
    }
    var bSelector$p = bSelector$1.tl;
    var match = Curry._2(SelectorTree$SmartcutsMacros.$$Node.Diff.withNode, aSelector$1.hd, bSelector$1.hd);
    if (typeof match === "number") {
      _bSelector = bSelector$p;
      _aSelector = aSelector$p;
      _result = undefined;
      continue ;
    }
    switch (match.TAG | 0) {
      case /* Id */0 :
      case /* TagName */1 :
          return false;
      case /* Index */2 :
          _bSelector = bSelector$p;
          _aSelector = aSelector$p;
          _result = undefined;
          continue ;
      case /* ClassNames */3 :
          if (match._2.length === 0) {
            return false;
          }
          _bSelector = bSelector$p;
          _aSelector = aSelector$p;
          _result = undefined;
          continue ;
      
    }
  };
}

function isSame(aSelector, bSelector) {
  if (selectsParentOrEquivElement(aSelector, bSelector)) {
    return selectsParentOrEquivElement(bSelector, aSelector);
  } else {
    return false;
  }
}

function nodeWithExtraAttributes(node, extraAttributes) {
  return {
          id: node.id,
          tagName: node.tagName,
          classNames: node.classNames,
          attributes: $$Array.append($$Array.of_list(extraAttributes), node.attributes),
          index: node.index,
          innerText: node.innerText,
          isScrollable: node.isScrollable,
          attributeBlacklist: node.attributeBlacklist
        };
}

function updateLeafNode(f, selector) {
  var len = List.length(selector);
  if (len === 0) {
    return selector;
  } else {
    return ListUtils$SmartcutsMacros.updateAt(List.length(selector) - 1 | 0, f, selector);
  }
}

function maybeGetLeafAnchor(selector) {
  var len = List.length(selector);
  if (len === 0) {
    return ;
  }
  var node = Belt_List.getExn(selector, len - 1 | 0);
  var match = node.tagName;
  if (match === undefined) {
    return ;
  }
  switch (match) {
    case "A" :
    case "a" :
        return node;
    default:
      return ;
  }
}

function isContentEditable(selector) {
  return Belt_List.some(selector, (function (selectorNode) {
                var match = SelectorTree$SmartcutsMacros.$$Node.maybeGetAttributeValue("contenteditable", selectorNode);
                if (match === undefined) {
                  return false;
                }
                switch (match) {
                  case "false" :
                      return false;
                  case "" :
                  case "true" :
                      return true;
                  default:
                    return false;
                }
              }));
}

function toCssSelectorForPattern(selector) {
  return Belt_Array.map($$Array.of_list(selector), (function (param) {
                  var arg = OptionUtils$SmartcutsMacros.map(param.id, (function (s) {
                          return "#" + window.CSS.escape(s);
                        }));
                  var arg$1 = OptionUtils$SmartcutsMacros.map(param.index, (function (i) {
                          return ":nth-child(" + (String(i) + ")");
                        }));
                  return OptionUtils$SmartcutsMacros.withDefault("*", param.tagName) + ((function (param) {
                                return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                              })("") + (Belt_Array.map(param.classNames, (function (className) {
                                      return "." + window.CSS.escape(className);
                                    })).join("") + (Belt_Array.map(param.attributes, (function (param) {
                                        var attrValue = param[1];
                                        return "[" + (window.CSS.escape(param[0]) + ((
                                                    attrValue.trim() === "" ? "" : "=" + StringUtils$SmartcutsMacros.quote(window.CSS.escape(attrValue))
                                                  ) + "]"));
                                      })).join("") + (function (param) {
                                    return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
                                  })(""))));
                })).join(" > ");
}

function splitForShadowDom(selector) {
  return Belt_Array.map(Belt_List.reduceWithIndex(selector, [], (function (splits, selectorNode, index) {
                    var maybeTagName = selectorNode.tagName;
                    if (maybeTagName !== undefined && DOM__Shadow$SmartcutsMacros.isNodeNameDocumentFragment(maybeTagName)) {
                      var indexOfLastSlice = splits.length - 1 | 0;
                      var lastSelectorSlice = indexOfLastSlice === -1 ? [] : Caml_array.get(splits, indexOfLastSlice);
                      var newSelectorSlice = [];
                      return $$Array.concat({
                                  hd: Belt_Array.slice(splits, 0, indexOfLastSlice),
                                  tl: {
                                    hd: [lastSelectorSlice],
                                    tl: {
                                      hd: index === (List.length(selector) - 1 | 0) ? [] : [newSelectorSlice],
                                      tl: /* [] */0
                                    }
                                  }
                                });
                    }
                    var indexOfLastSlice$1 = splits.length - 1 | 0;
                    var lastSelectorSlice$1 = indexOfLastSlice$1 === -1 ? [] : Caml_array.get(splits, indexOfLastSlice$1);
                    return $$Array.append(Belt_Array.slice(splits, 0, indexOfLastSlice$1), [$$Array.append(lastSelectorSlice$1, [selectorNode])]);
                  })), $$Array.to_list);
}

function factorOutDynamicVarsFromReverseSelector(remainingInnerTextLevelsOpt, reversedSelector) {
  var remainingInnerTextLevels = remainingInnerTextLevelsOpt !== undefined ? remainingInnerTextLevelsOpt : 2;
  if (!reversedSelector) {
    return {
            vars: [],
            factoredValue: reversedSelector
          };
  }
  var restReversedSelector = reversedSelector.tl;
  var lastNode = reversedSelector.hd;
  var innerText = lastNode.innerText;
  var match;
  if ((remainingInnerTextLevels - 1 | 0) === 0) {
    match = [
      [],
      restReversedSelector
    ];
  } else {
    var match$1 = factorOutDynamicVarsFromReverseSelector(remainingInnerTextLevels - 1 | 0, restReversedSelector);
    match = [
      match$1.vars,
      match$1.factoredValue
    ];
  }
  var nextRestReversedSelector = match[1];
  var nextVars = match[0];
  if (typeof innerText === "number") {
    if (innerText === /* Ignored */0) {
      return {
              vars: [],
              factoredValue: reversedSelector
            };
    } else {
      return {
              vars: [],
              factoredValue: reversedSelector
            };
    }
  } else if (innerText.TAG === /* FullInnerText */0) {
    return {
            vars: $$Array.append([innerText._0], nextVars),
            factoredValue: {
              hd: {
                id: lastNode.id,
                tagName: lastNode.tagName,
                classNames: lastNode.classNames,
                attributes: lastNode.attributes,
                index: lastNode.index,
                innerText: {
                  TAG: /* FullInnerText */0,
                  _0: ""
                },
                isScrollable: lastNode.isScrollable,
                attributeBlacklist: lastNode.attributeBlacklist
              },
              tl: nextRestReversedSelector
            }
          };
  } else {
    return {
            vars: $$Array.append([innerText._0], nextVars),
            factoredValue: {
              hd: {
                id: lastNode.id,
                tagName: lastNode.tagName,
                classNames: lastNode.classNames,
                attributes: lastNode.attributes,
                index: lastNode.index,
                innerText: {
                  TAG: /* TruncatedInnerText */1,
                  _0: "",
                  _1: innerText._1
                },
                isScrollable: lastNode.isScrollable,
                attributeBlacklist: lastNode.attributeBlacklist
              },
              tl: nextRestReversedSelector
            }
          };
  }
}

function factorOutDynamicVars(selector) {
  var reversedSelector = List.rev(selector);
  var match = factorOutDynamicVarsFromReverseSelector(undefined, reversedSelector);
  return {
          vars: match.vars,
          factoredValue: List.rev(match.factoredValue)
        };
}

function substituteInDynamicVarsForReverseSelector($staropt$star, param) {
  var factoredReversedSelector = param.factoredValue;
  var vars = param.vars;
  var remainingInnerTextLevels = $staropt$star !== undefined ? $staropt$star : 2;
  if (!factoredReversedSelector) {
    return factoredReversedSelector;
  }
  var rest = factoredReversedSelector.tl;
  var lastNode = factoredReversedSelector.hd;
  var innerText = lastNode.innerText;
  var nextRest = (remainingInnerTextLevels - 1 | 0) === 0 ? rest : substituteInDynamicVarsForReverseSelector(remainingInnerTextLevels - 1 | 0, {
          vars: Belt_Array.slice(vars, 1, vars.length - 1 | 0),
          factoredValue: rest
        });
  if (typeof innerText === "number") {
    return {
            hd: lastNode,
            tl: nextRest
          };
  }
  if (innerText.TAG === /* FullInnerText */0) {
    var arg = Js_json.decodeString(Caml_array.get(vars, 0));
    var text = (function (param) {
          return OptionUtils$SmartcutsMacros.getExn(param, arg);
        })("Expected inner text to be string");
    return {
            hd: {
              id: lastNode.id,
              tagName: lastNode.tagName,
              classNames: lastNode.classNames,
              attributes: lastNode.attributes,
              index: lastNode.index,
              innerText: {
                TAG: /* FullInnerText */0,
                _0: text
              },
              isScrollable: lastNode.isScrollable,
              attributeBlacklist: lastNode.attributeBlacklist
            },
            tl: nextRest
          };
  }
  var arg$1 = Js_json.decodeString(Caml_array.get(vars, 0));
  var text$1 = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
      })("Expected inner text to be string");
  return {
          hd: {
            id: lastNode.id,
            tagName: lastNode.tagName,
            classNames: lastNode.classNames,
            attributes: lastNode.attributes,
            index: lastNode.index,
            innerText: {
              TAG: /* TruncatedInnerText */1,
              _0: text$1,
              _1: innerText._1
            },
            isScrollable: lastNode.isScrollable,
            attributeBlacklist: lastNode.attributeBlacklist
          },
          tl: nextRest
        };
}

function substituteInDynamicVars(param) {
  return List.rev(substituteInDynamicVarsForReverseSelector(undefined, {
                  vars: param.vars,
                  factoredValue: List.rev(param.factoredValue)
                }));
}

var Pack = {
  factorOutDynamicVars: factorOutDynamicVars,
  substituteInDynamicVars: substituteInDynamicVars
};

var defaultKeepLastNLevelsOfInnerText = 2;

var maybeGetLeafNode = SelectorTree$SmartcutsMacros.maybeGetLeafNode;

exports.Attributes = Attributes;
exports.selectorNode_encode = selectorNode_encode;
exports.selectorNode_decode = selectorNode_decode;
exports.selector_encode = selector_encode;
exports.selector_decode = selector_decode;
exports.elementSelector_encode = elementSelector_encode;
exports.elementSelector_decode = elementSelector_decode;
exports.selectorNode = selectorNode;
exports.addNode = addNode;
exports.stringify = stringify;
exports.stringifyElementSelector = stringifyElementSelector;
exports.defaultKeepLastNLevelsOfInnerText = defaultKeepLastNLevelsOfInnerText;
exports.hasSelectionCapability = hasSelectionCapability;
exports.deepEquals = deepEquals;
exports.shouldIgnoreId = shouldIgnoreId;
exports.attributesToAvoidComparing = attributesToAvoidComparing;
exports.pruneSelectorTreeNodeUsingOriginBlacklist = pruneSelectorTreeNodeUsingOriginBlacklist;
exports.toCssSelectorUsingTagChainAndAttributeExistence = toCssSelectorUsingTagChainAndAttributeExistence;
exports.removeGeneratedIdsFromSelector = removeGeneratedIdsFromSelector;
exports.blacklistAttributeValues = blacklistAttributeValues;
exports.forDomElement = forDomElement;
exports.forHtmlElement = forHtmlElement;
exports.forDomEventTarget = forDomEventTarget;
exports.forDomEvent = forDomEvent;
exports.$$Node = $$Node;
exports.stripGeneratedIds = stripGeneratedIds$1;
exports.getCommonAncestor = getCommonAncestor;
exports.selectsParentOrEquivElement = selectsParentOrEquivElement;
exports.isSame = isSame;
exports.nodeWithExtraAttributes = nodeWithExtraAttributes;
exports.maybeGetLeafNode = maybeGetLeafNode;
exports.updateLeafNode = updateLeafNode;
exports.maybeGetLeafAnchor = maybeGetLeafAnchor;
exports.isContentEditable = isContentEditable;
exports.toCssSelectorForPattern = toCssSelectorForPattern;
exports.splitForShadowDom = splitForShadowDom;
exports.Pack = Pack;
/* Webapi__Dom__Element Not a pure module */
